import React, {
  useEffect,
  useContext,
  useState
} from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  faDesktop,
  faUserFriends,
  faBoxOpen,
  faFile,
  faMap,
  faClock,
  faLink,
  faComments
  // faAtlas
} from '@fortawesome/free-solid-svg-icons';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
  makeStyles
} from '@material-ui/core';
import NavItem from './NavItem';

import { AuthContext } from '../../../shared/context/auth-context';

const items = [
  {
    href: '/app/dashboard',
    icon: faDesktop,
    title: 'Painel Principal',
    permissoes: [],
  },
  {
    href: '/app/acervos',
    icon: faBoxOpen,
    title: 'Itens de Acervo',
    permissoes: ['list_acervos']
  },
  {
    href: '/app/relatorios',
    icon: faFile,
    title: 'Relatórios',
    permissoes: ['relatorios']
  },
  {
    href: '/app/mapas',
    icon: faMap,
    title: 'Mapa da Reserva Técnica',
    permissoes: ['list_mapas']
  },
  {
    href: '/app/usuarios',
    icon: faUserFriends,
    title: 'Usuários',
    permissoes: ['all_admin']
  },
  {
    href: '/app/registros',
    icon: faClock,
    title: 'Registros',
    permissoes: ['relatorios']
  },
  {
    href: '/app/front',
    icon: faLink,
    title: 'Conteúdo do Site',
    permissoes: ['all_admin']
  },
  {
    href: '/app/emprestimos',
    icon: faComments,
    title: 'Solicitações',
    permissoes: ['all_admin']
  },
  /* {
    href: '/app/tutoriais',
    icon: faAtlas,
    title: 'Tutoriais',
    permissoes: []
  }, */
];

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 104,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();
  const auth = useContext(AuthContext);
  const [rotas, setRotas] = useState(items);
  let user = {
    avatar: '',
    jobTitle: '',
    name: ''
  };

  if (auth.isLoggedIn && auth.userPermission !== null && auth.userPermission !== false) {
    user = {
      avatar: auth.userAvatar ? `${process.env.REACT_APP_BACKEND_IMG}${auth.userAvatar.caminho}` : '',
      jobTitle: auth.userPermission.nome,
      name: auth.userName
    };
  }

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (auth.userPermission !== false && auth.userPermission !== null) {
      switch (auth.userPermission.nome) {
        case 'Gestor do Sistema':
          setRotas(items);
          break;
        default:
          setRotas(items.filter((item) => item.permissoes.some((p) => auth.userPermission.permissoes.includes(p)) || item.permissoes.length === 0));
          break;
      }
    }
  }, [auth.userPermission]);

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={2}
      >
        <Avatar
          className={classes.avatar}
          component={RouterLink}
          src={user.avatar}
          to="/app/perfil"
        />
        <Typography
          className={classes.name}
          color="textPrimary"
          variant="h5"
        >
          {user.name}
        </Typography>
        <Typography
          color="textSecondary"
          variant="body2"
        >
          {user.jobTitle}
        </Typography>
      </Box>
      <Divider />
      <Box p={2}>
        <List>
          {rotas.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box flexGrow={1} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default NavBar;
